export default {"src":"/_next/static/media/time_grey.a9ec7f4c.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};